<template>
  <div>
    <div class="h370 rdiv">
      <div class="h295">
        <!--v-tree ref='tree' :data='data' :halfcheck='true' :multiple="true" :selectAlone="true" @node-check="getCheckedNodes" /-->
        <treeselect
          :multiple="true"
          :options="options"
          :show-count="true"
          sort-value-by="INDEX"
          valueFormat = "object"
          value-consists-of="ALL_WITH_INDETERMINATE"
          placeholder="--请设置角色对应菜单--"
          v-model="selectedValues"
          @select="getCheckedNodes"
          @input="getCheckedNodes"
        >
        </treeselect>
        <!--{{selectedValues}}-->
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import Bus from '@/utils/bus'
  // import 'vue-tree-halower/dist/halower-tree.min.css' // you can customize the style of the tree
  // import { VTree, VSelectTree } from 'vue-tree-halower'
  import Treeselect from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import clonedeep from 'lodash.clonedeep'
  import utils from '@/utils'
  // Vue.use(VTree)
  // Vue.use(VSelectTree)
  export default {
    name: "treemenu",
    components: { Treeselect },
    created () {
      this.options = this.dealTree(clonedeep(this.data))
      if (!this.selected) {
        this.selectedValues = []
      } else {
        if (this.selected.length > 0) {
          let children = utils.flattern(clonedeep(this.selected)).filter((o) => {
            return !o.children
          })
          this.selectedValues = children
        } else {
          this.selectedValues = []
        }
      }
    },
    destroyed () {
      this.selectedValues = []
    },
    data () {
      return {
        selectedValues: [],
        options: []
      }
    },
    methods: {
      dealTree (arr) {
        var dealArr = []
        if (arr && arr.length > 0) {
          for (var i = 0; i< arr.length; i++) {
            var temp = {
              id: arr[i].id,
              label: arr[i].name
            };
            if (arr[i].children && arr[i].children.length > 0) {
              temp.children = this.dealTree(arr[i].children)
            }
            dealArr.push(temp)
          }
        }
        return dealArr
      },
      getCheckedNodes (nodes) {
        // let nodes = this.$refs.tree.getCheckedNodes(true)
        if (nodes.length > 0) {
          nodes.forEach((o) => {
            o.name = o.label
          })
        }
        Bus.$emit('selected-menu', nodes)
      }
    },
    props: ['data', 'selected']
  }
</script>

<style>
  .halo-tree .check { left: 0 !important; top: 0 !important; }
</style>



// WEBPACK FOOTER //
// src/page/byl/sys/role/treemenu.vue